import { useContext, useEffect } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import { onSave, onMaxExpChange, onChangeTitle, onChangeCompanyName } from './JobPostingAction';
import JobPostingLayout from './JobPostingLayout';
import PageConfig from './PageConfig.json';

const JobPosting = () => {
    const { id, pageName } = useParams();
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            SAVE: onSave,
            ROUTER_NAVIGATE: navigate,
            maxExperience: onMaxExpChange,
            title: onChangeTitle,
            companyName: onChangeCompanyName,
        },
    } as any);

    const { data } = useLoaderData() as State;
    const userData = JSON.parse(localStorage.getItem('user') ?? '{}');
    // const schoolId = sessionStorage.getItem('user-school-id') ?? JSON.parse(sessionStorage.getItem('user') ?? '')?.instituteId;
    const schoolId = userData?.instituteId ?? userData?.primaryInstitute;
    // const studentId = JSON.parse(sessionStorage.getItem('user') ?? '')?.id;
    const studentId = userData?.id ?? userData?.userId;

    useEffect(() => {
        data.jobPostVisibleTo = data.jobPostVisibleTo ?? [];
        const domain = globalState.domain;

        const jobPostingVisibity =
            data?.jobPostVisibleTo?.length
                ? data.jobPostVisibleTo.map((item: any) => ({
                    instituteId: schoolId,
                    programId: item?.programId ?? '',
                    passOutYear : item?.passOutYear ?? []
                })): [{instituteId: schoolId, programId: '',passOutYear : []}];

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig : PageConfig as any,
                data: { jobPosting: { ...data.data, schoolId, studentId },jobPostingVisibity: jobPostingVisibity },
                domain,
                routeInfo: { id, pageName },
            },
        });
    }, [id]);

    useEffect(() => {
        let jobPostingVisibity = state?.data?.jobPostingVisibity?.length ?
        state?.data?.jobPostingVisibity.map((item: any) => ({
                    instituteId: schoolId,
                    programId: item?.programId ?? '',
                    passOutYear : item?.passOutYear ?? []
                })) : [{instituteId: schoolId, programId: '',passOutYear : []}];

        dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey : 'jobPostingVisibity', value: jobPostingVisibity },
        });
    }, [state?.data?.jobPostingVisibity?.length]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <JobPostingLayout>{!state.flags.isDataLoading && <PageBuilder />}</JobPostingLayout>
        </SmartContext.Provider>
    );
};
export default JobPosting;
